import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Update Farm", -1)
const _hoisted_3 = { class: "nes-field mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "manager" }, "New farm manager", -1)
const _hoisted_5 = { class: "nes-field mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "minStakingPeriodSec" }, "Min staking period (sec)", -1)
const _hoisted_7 = { class: "nes-field mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "cooldownPeriodSec" }, "Cooldown period (sec)", -1)
const _hoisted_9 = { class: "nes-field mb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "unstakingFeeLamp" }, "Unstaking fee (lamports)", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "nes-btn is-primary mb-5",
  type: "submit"
}, "Update farm", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateFarm && _ctx.updateFarm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "manager",
          class: "nes-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.manager) = $event))
        }, null, 512), [
          [_vModelText, _ctx.manager]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "minStakingPeriodSec",
          class: "nes-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minStakingPeriodSec) = $event))
        }, null, 512), [
          [_vModelText, _ctx.minStakingPeriodSec]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "cooldownPeriodSec",
          class: "nes-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cooldownPeriodSec) = $event))
        }, null, 512), [
          [_vModelText, _ctx.cooldownPeriodSec]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "unstakingFeeLamp",
          class: "nes-input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.unstakingFeeLamp) = $event))
        }, null, 512), [
          [_vModelText, _ctx.unstakingFeeLamp]
        ])
      ]),
      _hoisted_11
    ], 32)
  ]))
}